module.exports = __webpack_public_path__ + "static/index-static-895fa77f3f6ab8739eb60e969a2a5805.png";